import { Dispatch } from "redux";
import { fetchStorageConfigsPending, fetchStorageConfigsSuccess, fetchStorageConfigsError } from "../redux/actions/StorageConfigAction";
import StorageApi from "../api/StorageApi";

export function fetchStorageConfigs(isWithLoading: boolean = true) {
  return (dispatch: Dispatch) => {
    if (isWithLoading) dispatch(fetchStorageConfigsPending());
    StorageApi.getStorageConfigs()
      .then((storageConfigs) => {
        dispatch(fetchStorageConfigsSuccess(storageConfigs));
      })
      .catch((error) => {
        dispatch(fetchStorageConfigsError(error));
      });
  };
}
